import { MenuItem } from '@consigli/facade';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface TopicDropdownContentProps {
  topics: string[];
  /** Currently selected topic, highlighted in the list (individual edit context). */
  selectedTopic?: string | null;
  /** Show the "Clear topic" option at the top of the list. */
  showClearOption?: boolean;
  onSelect: (topic: string) => void;
  onClear?: () => void;
}

/**
 * Shared topic dropdown body rendered in both individual and bulk edit contexts.
 * Renders the "Clear topic" option and the list of topics. The custom-topic
 * affordance lives in TopicDropdownFooter (passed to DropdownMenu's `footer`).
 * Ensures consistent UI/UX across the application.
 */
export const TopicDropdownContent: FC<TopicDropdownContentProps> = ({
  topics,
  selectedTopic,
  showClearOption = false,
  onSelect,
  onClear,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {showClearOption && (
        <MenuItem onClick={() => onClear?.()} className="hover:bg-gray-100 text-gray-400 italic">
          {t('meeting-secretary.action-items.clear-topic', 'Clear topic')}
        </MenuItem>
      )}
      {topics.map((topic) => (
        <MenuItem
          key={topic}
          selected={topic === selectedTopic}
          onClick={() => onSelect(topic)}
          className="hover:bg-gray-100"
        >
          <span className="text-sm text-gray-900">{topic}</span>
        </MenuItem>
      ))}
    </>
  );
};
